import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class PaymentSettingsAccessPermissionError extends CodedError {
  static get errorName() {
    return errorCodes.paymentSettingsAccessPermission.code;
  }

  constructor(message: string = errorCodes.paymentSettingsAccessPermission.message) {
    super(message);
    this.code = errorCodes.paymentSettingsAccessPermission.code;
    this.message = `${message} ${errorCodes.paymentSettingsAccessPermission.code}`;
    this.name = errorCodes.paymentSettingsAccessPermission.name;
  }
}
